<template>
    <div class="card">
        <div v-if="loading" class="card-body">
            <Spinner spinner-type="grow" min-height="467px" />
        </div>
        <div v-else class="card-body parent-c-b">
            <main id="circle-main" class="">
                <svg id="circle-svg" width="615" height="613" viewBox="0 0 615 613" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_933_6175)">
                        <path
                            d="M548.2 447.35C561.54 455.18 578.83 450.76 585.41 436.76C619.781 363.649 623.984 279.946 597.11 203.76C591.96 189.18 575.21 183.05 561.11 189.5L458.72 236.5C444.67 242.95 438.81 259.57 442.31 274.63C448.182 299.868 446.858 326.247 438.49 350.77C433.49 365.4 437.66 382.52 450.99 390.35L548.2 447.35Z"
                            fill="#03AFBF" data-index="0" />
                        <path
                            d="M550.499 168.379C563.949 160.739 568.759 143.559 559.929 130.859C513.788 64.5171 443.372 19.0197 363.929 4.21922C348.729 1.37922 335.039 12.8292 333.599 28.2192L323.119 140.399C321.679 155.799 333.118 169.179 347.938 173.679C372.721 181.218 394.894 195.553 411.938 215.059C422.118 226.699 439.029 231.659 452.469 224.059L550.499 168.379Z"
                            fill="#6C3AA2" data-index="5" />
                        <path
                            d="M309.599 27.02C309.709 11.55 297.239 -1.19998 281.829 0.0900234C201.321 6.8799 126.724 45.0964 74.1792 106.47C64.1192 118.22 67.1792 135.79 79.7992 144.74L171.699 209.92C184.319 218.86 201.629 215.62 212.929 205.06C231.85 187.357 255.357 175.314 280.779 170.3C295.949 167.3 308.699 155.14 308.779 139.68L309.599 27.02Z"
                            fill="#95479B" data-index="4" />
                        <path
                            d="M66.4104 164.63C53.0704 156.81 35.7903 161.23 29.2103 175.22C-5.15896 248.331 -9.36202 332.034 17.5104 408.22C22.6504 422.81 39.4103 428.94 53.4603 422.49L155.86 375.49C169.86 369.04 175.76 352.42 172.26 337.36C166.404 312.112 167.741 285.727 176.12 261.2C181.12 246.56 176.95 229.44 163.61 221.61L66.4104 164.63Z"
                            fill="#093F65" data-index="3" />
                        <path
                            d="M64.439 443.929C50.989 451.569 46.1791 468.749 55.0091 481.449C101.138 547.781 171.534 593.277 250.959 608.089C266.159 610.929 279.849 599.479 281.289 584.089L291.779 471.909C293.219 456.509 281.779 443.129 266.959 438.629C242.177 431.089 220.005 416.754 202.959 397.249C192.779 385.609 175.869 380.649 162.419 388.249L64.439 443.929Z"
                            fill="#045B8E" data-index="2" />
                        <path
                            d="M305.341 585.29C305.231 600.76 317.701 613.52 333.111 612.22C413.619 605.43 488.216 567.214 540.761 505.84C550.821 494.09 547.761 476.52 535.141 467.57L443.241 402.39C430.621 393.45 413.311 396.69 402.011 407.25C383.078 424.96 359.557 437.003 334.121 442.01C318.951 445.01 306.201 457.17 306.121 472.63L305.341 585.29Z"
                            fill="#0585BA" data-index="1" />
                        <path
                            d="M307.512 424.199C372.681 424.199 425.512 371.369 425.512 306.199C425.512 241.03 372.681 188.199 307.512 188.199C242.342 188.199 189.512 241.03 189.512 306.199C189.512 371.369 242.342 424.199 307.512 424.199Z"
                            fill="white" stroke="#FFBE60" stroke-width="10" />
                    </g>
                    <defs>
                        <clipPath id="clip0_933_6175">
                            <rect width="614.62" height="612.31" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <figure id="figure">
                    <div class="figure-text">
                        <h4 class="figure-text-increment">{{ en_to_bn('01') }}</h4>
                        <h4 class="figure-text-title">{{ __('Teacher') }}</h4>
                    </div>
                    <div class="figure-widget-parent">
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color='#03AFBF'>
                                <p class="number m-0">{{ en_to_bn('01') }}</p>
                                <p class="title m-0">{{ __('Teacher') }}</p>
                            </div>
                            <ul class="item-details">
                                <li>
                                    <span>{{ __('Total Teachers') }}</span>
                                    <span>{{ en_to_bn(counts.user_count.total_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Male') }} {{ __('Teacher') }}</span>
                                    <span>{{ en_to_bn(counts.user_count.male_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Female') }} {{ __('Teacher') }}</span>
                                    <span>{{ en_to_bn(counts.user_count.female_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Others') }}</span>
                                    <span>{{ en_to_bn(counts.user_count.others_gender_count) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color="#0585BA">
                                <p class="number m-0">{{ en_to_bn('02') }}</p>
                                <p class="title m-0">{{ __('Ambassador') }}</p>
                            </div>
                            <ul class="item-details">
                                <li>
                                    <span>{{ __('Total') }} {{ __('Ambassador') }}</span>
                                    <span>{{ en_to_bn(counts.ambassador_count.total_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Male') }} {{ __('Ambassador') }}</span>
                                    <span>{{ en_to_bn(counts.ambassador_count.male_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Female') }} {{ __('Ambassador') }}</span>
                                    <span>{{ en_to_bn(counts.ambassador_count.female_count) }}</span>
                                </li>
                                <li>
                                    <span>{{ __('Others') }}</span>
                                    <span>{{ en_to_bn(counts.ambassador_count.others_gender_count) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color="#045B8E">
                                <p class="number m-0">{{ en_to_bn('03') }}</p>
                                <p class="title m-0">{{ __('Institution') }}</p>
                            </div>
                            <ul class="item-details">
                                <li>
                                    <span>{{ __('Total') }} {{ __('Institution') }}</span>
                                    <span>{{ en_to_bn(counts.institution_count.total) }}</span>
                                </li>
                                <li v-for="(item, i) in counts.institution_count.type_wise" :key="i">
                                    <span>{{ locale_attr(item, 'type_{lang}_name') }}</span>
                                    <span>{{ en_to_bn(item.count) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color="#093F65">
                                <p class="number m-0">{{ en_to_bn('04') }}</p>
                                <p class="title m-0">{{ __('Contents') }}</p>
                            </div>
                            <ul class="item-details">
                                <li>
                                    <span>{{ __('Total') }} {{ __('Contents') }}</span>
                                    <span>{{ en_to_bn(counts.content_count.total) }}</span>
                                </li>
                                <li v-for="(item, i) in counts.content_count.type_wise" :key="i">
                                    <span>{{ locale_attr(item, 'type_name_{lang}') }}</span>
                                    <span>{{ en_to_bn(item.count) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color="#95479B">
                                <p class="number m-0">{{ en_to_bn('05') }}</p>
                                <p class="title m-0">{{ __('District') }}</p>
                            </div>
                            <ul class="item-details">
                                <li v-for="(district, i) in counts.top_districts" :key="i">
                                    <span>{{ locale_attr(district, 'district_name_{lang}g') }}</span>
                                    <span>{{ en_to_bn(district.users_count) }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="figure-widget">
                            <div class="figure-widget-content" data-color="#6C3AA2">
                                <p class="number m-0">{{ en_to_bn('06') }}</p>
                                <p class="title m-0">{{ __('Upazila') }}</p>
                            </div>
                            <ul class="item-details">
                                <li v-for="(upazila, i) in counts.top_upazilas" :key="i">
                                    <span>{{ locale_attr(upazila, 'upazila_name_{lang}g') }}</span>
                                    <span>{{ en_to_bn(upazila.users_count) }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </figure>
            </main>
            <div class="right">
                <div class="card">
                    <div class="card-body">
                        <h5 class="main-title">{{ __('Teacher') }}</h5>
                        <ul>
                            <li>
                                <span>{{ __('Total Teachers') }}</span>
                                <span>{{ en_to_bn(counts.user_count.total_count) }}</span>
                            </li>
                            <li>
                                <span>{{ __('Male') }} {{ __('Teacher') }}</span>
                                <span>{{ en_to_bn(counts.user_count.male_count) }}</span>
                            </li>
                            <li>
                                <span>{{ __('Female') }} {{ __('Teacher') }}</span>
                                <span>{{ en_to_bn(counts.user_count.female_count) }}</span>
                            </li>
                            <li>
                                <span>{{ __('Others') }}</span>
                                <span>{{ en_to_bn(counts.user_count.others_gender_count) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Spinner from '../../components/Spinner';

const pathNames = [
    'Teacher',
    'Ambassador',
    'Institution',
    'Content',
    'District',
    'Upazila',
];

export default {
    components: {
        Spinner,
    },

    emits: ['click:path'],

    data() {
        return {
            counts: {
                user_count: {
                    male_count: 0,
                    female_count: 0,
                    others_gender_count: 0,
                    total_count: 0,
                },
                ambassador_count: {
                    male_count: 0,
                    female_count: 0,
                    others_gender_count: 0,
                    total_count: 0,
                },
                institution_count: {
                    type_wise: [],
                    total: 0,
                },
                content_count: {
                    type_wise: [],
                    total: 0,
                },
                top_districts: [],
                top_upazilas: [],
            },
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        async fetchCounts() {
            this.loading = true;
            await axios.get('/dashboard/wheel-data')
                .then(({ data }) => this.counts = data.counts)
                .catch(console.error);

            this.loading = false;
            this.$nextTick(() => {
                this.initWheelRotation();
            });
        },

        initWheelRotation() {
            const vm = this;
            var totalCircle = 6;
            var perDegree = 360 / totalCircle;

            $(".figure-widget").each(function (i) {
                $(this).attr("data-index", i);
            });

            $("#circle-svg").on("click", "path", function () {
                var index = $(this).data("index");
                var deg = perDegree * index * -1 + "deg";

                vm.$emit('click:path', pathNames[index]);

                if (index || index === 0) {
                    $("#circle-main").css({ "--r": deg });
                    $("#circle-main .figure-widget-content").css({ "--r": deg });
                    if ($(window).width() < 767) {
                        console.log('mobile')
                        $("#circle-main .figure-widget-content").css({ "--r": `${perDegree * index * - 1 + 88}deg` });
                    } else {
                        console.log('mobile up')
                        
                        $("#circle-main .figure-text").css({ "--r": deg });
                    }

                    // replace right side card with this current data
                    var item = $(`#figure [data-index=${index}]`);
                    var lis = $(item).find('.item-details').html();
                    var newHtml = `<ul>${lis}</ul>`;
                    $('#public_dashboard .animating_div .animated_circle .right .card .card-body ul').replaceWith(newHtml);

                    var number = $(item).find(".number").text();
                    var title = $(item).find(".title").text();
                    var color = $(item).find('.figure-widget-content').data("color");

                    // circle details
                    $("#figure .figure-text-increment").text(number);
                    $("#figure .figure-text-title").text(title);
                    $("#public_dashboard .animating_div .figure-text").css({ "--text-clr": color });

                    // right side card details
                    $("#public_dashboard .animating_div .animated_circle .right .card .main-title").text(title);
                    $("#public_dashboard .animating_div .animated_circle .right .card").css({ "--bg-color": color });
                }
            });
        },
    },
}
</script>